import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')


	return {
		"id": id,
		"elements": [{
			"type": "text",
			"id": "VraVRllNDX",
			"width": 633.33,
			"height": 112.84375,
			"left": 189.83499999999998,
			"top": 198.86842669845055,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#fff",
			"content": `<p style=\"text-align: center;\"><strong><span style=\"font-size: 91.84px;\"><span style=\"font-family: Arial;\">${title}</span></span></strong></p>`,
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "shape",
			"id": "aNsa3xU2wq",
			"width": 120.57,
			"height": 120.57,
			"left": 284.23999999999995,
			"top": 76.72,
			"viewBox": [
				200,
				200
			],
			"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
			"fill": "none",
			"fixedRatio": false,
			"rotate": 45,
			"outline": {
				"color": "#6c4120",
				"width": 1.75,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "7YfQd6nCLN",
			"width": 102.47,
			"height": 102.47,
			"left": 284.24999999999994,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "-bfjtqsRZf",
			"width": 102.47,
			"height": 102.47,
			"left": 284.24999999999994,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "mpXQihA9D4",
			"width": 102.47,
			"height": 102.47,
			"left": 284.24999999999994,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "FosDV8AIWd",
			"width": 120.57,
			"height": 120.57,
			"left": 392.19,
			"top": 76.72,
			"viewBox": [
				200,
				200
			],
			"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
			"fill": "none",
			"fixedRatio": false,
			"rotate": 45,
			"outline": {
				"color": "#6c4120",
				"width": 1.75,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "KoTARdcBfx",
			"width": 102.47,
			"height": 102.47,
			"left": 392.2,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "oQViaBaau-",
			"width": 102.47,
			"height": 102.47,
			"left": 392.2,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "Wo_KfW49XN",
			"width": 102.47,
			"height": 102.47,
			"left": 392.2,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "bFJTLytRfr",
			"width": 120.57,
			"height": 120.57,
			"left": 506.49,
			"top": 76.72,
			"viewBox": [
				200,
				200
			],
			"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
			"fill": "none",
			"fixedRatio": false,
			"rotate": 45,
			"outline": {
				"color": "#6c4120",
				"width": 1.75,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "0K5OJypANi",
			"width": 102.47,
			"height": 102.47,
			"left": 506.5,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "LusJVXhYwH",
			"width": 102.47,
			"height": 102.47,
			"left": 506.5,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "W5Tq8TrhT1",
			"width": 102.47,
			"height": 102.47,
			"left": 506.5,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "1B0YO4Wc7m",
			"width": 120.57,
			"height": 120.57,
			"left": 614.44,
			"top": 76.72,
			"viewBox": [
				200,
				200
			],
			"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
			"fill": "none",
			"fixedRatio": false,
			"rotate": 45,
			"outline": {
				"color": "#6c4120",
				"width": 1.75,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "xK0TucCFR9",
			"width": 102.47,
			"height": 102.47,
			"left": 614.45,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "BQOD5OT43A",
			"width": 102.47,
			"height": 102.47,
			"left": 614.45,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "M7V7Rb-GLq",
			"width": 102.47,
			"height": 102.47,
			"left": 614.45,
			"top": 76.73,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 1.5,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "text",
			"id": "38SVTTjf9j",
			"width": 400.05,
			"height": 76.09375,
			"left": 296.94,
			"top": 89.42,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333333",
			"content": "<p style=\"text-align: justify;\"><span style=\"font-size: 55.1px;\"><span style=\"font-family: Arial;\">第</span></span></p>",
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "shape",
			"id": "CaF3CUVDio",
			"width": 9.93,
			"height": 9.91,
			"left": 939.21,
			"top": 281.31,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "9-238sRMe5",
			"width": 9.93,
			"height": 9.91,
			"left": 954.12,
			"top": 281.31,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "CWjVnWQVcx",
			"width": 9.93,
			"height": 9.91,
			"left": 964.05,
			"top": 281.31,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "1g55j2WTfy",
			"width": 9.93,
			"height": 9.91,
			"left": 24.88,
			"top": 281.31,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "6erczJLpVo",
			"width": 9.93,
			"height": 9.91,
			"left": 39.79,
			"top": 281.31,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "shape",
			"id": "myfepQ4nZ5",
			"width": 9.93,
			"height": 9.91,
			"left": 49.72,
			"top": 281.31,
			"viewBox": [
				200,
				200
			],
			"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
			"fill": "#cb834d",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#6c4120",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体旧字形 Light;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "text",
			"id": "eMaAkNHzI-",
			"left": 634.625864607662,
			"top": 87.965,
			"width": 34.809999999999945,
			"height": 80,
			"content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 40px;\">节</span></strong></p>",
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333333",
			"vertical": false
		},
		{
			"type": "text",
			"id": "RDLflsTuQb",
			"left": 475.85956769616894,
			"top": 87.965,
			"width": 163.7508646076621,
			"height": 80,
			"content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 40px;\">章</span></strong></p>",
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333333",
			"vertical": false
		},
		{
			"type": "text",
			"id": "U6bmC_JJJ-",
			"left": 392.2,
			"top": 87.96500000000002,
			"width": 80.78069129916571,
			"height": 80,
			"content": `<p style=\"text-align: center;\"><strong><span style=\"font-size: 40px;\">${serial}</span></strong></p>`,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#fff",
			"vertical": false
		}
		],
		background
	};

}